<template>
  <div class="opc-nav">
    <h1 class="opc-nav__title">{{ title }}</h1>
    <div class="opc-nav__main">
      <zm-breadcrumb separator-class="zm-icon-right">
        <zm-breadcrumb-item
          v-for="(route, index) in routes"
          data-testid="checkout-breadcrumb-33"
          :key="index"
          v-bind="linkable(index) ? { to: { path: `${route.path}` } } : {}"
        >
          <span :class="{ 'is-active': route.path === $route.path }">{{ route.title }}</span>
        </zm-breadcrumb-item>
      </zm-breadcrumb>
    </div>
  </div>
</template>

<script>
import { lowerCase } from "lodash";
import { routes } from '@/router/index';
import { mapState, mapActions } from 'vuex';
import store from '@/store/index';
import { isCurrencySwitch } from '@/utils/currency';
// const SERVER_ROOT = process.env.VUE_APP_REMOTE_SERVER_ROOT;
// let isFrist = true;

export default {
  data() {
    return {
      isFrist: true,
    };
  },
  computed: {
    ...mapState({
      proIncreaseMapMonthly: state => state.ShoppingCart.proIncreaseMapMonthly,
      proIncreaseMapYearly: state => state.ShoppingCart.proIncreaseMapYearly,
    }),
    routes() {
      // two step nav that is ** only ** used in config > checkout view
      return routes.slice(0, 2);
    },
    currentRoute() {
      const route = routes.find((x) => x.path === this.$route.path);
      return route;
    },
    title() {
      return this.currentRoute?.title;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        const { addressInfo } = store.getters;
        // PRO INCREASE - restore the price for Pro if user nav back to config page when address not save only https://zoomvideo.atlassian.net/browse/ZOOM-629660
        if(route && route.path === '/config' && !addressInfo?.country) {
          this.restoreProMonthlyAndYearlyPriceWhenNavBack();
        }
        window.document.title = `${this.currentRoute.title} - Zoom`;
      },
    },
  },
  methods: {
    ...mapActions(['restoreProMonthlyAndYearlyPriceWhenNavBack']),
    linkable(idx) {
      if (isCurrencySwitch() && idx === 0) {
        return false;
      }
      const index = this.routes.findIndex((x) => x.path === this.currentRoute.path);
      if (index === idx) {
        if (!this.isFrist) {
          this.$tracking.buyInteraction("checkout payment method", `navigation - ${lowerCase(this.currentRoute?.title)}`);
        }
        this.isFrist = false;
      }
      return idx < index;
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
.opc-nav {
  display: flex;
  align-items: center;
  font-family: $happy-display;
  &__title {
    font-weight: 400;
    font-size: 24px;
    line-height: 48px;
    color: #000000;
    @include media(mobile){
      display: none;
    }
    @include media(tablet){
      font-size: 24px;
    }
  }
  &__main {
    margin-left: auto;
    @include media(mobile){
      margin-left: unset;
    }
  }
  .zm-breadcrumb {
    line-height: 18px;
    &__item {
      height: 18px;
    }
    &__inner {
      font-weight: 700 !important;
      font-size: 14px;
      line-height: 18px;
      // colors overwrite
      color: #666487 !important;
      &.is-link {
        color: #515079 !important;
      }
      & .is-active {
        color: #00053d !important;
      }
    }
  }
}
</style>
